import axios from 'axios';

const getDriverAPIURL = () => {
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  return isLocalhost
    ? 'http://localhost/syra%20food%20point%20seguku/backend/api/driver'
    : `${window.location.origin}/backend/api/driver`;
};

const DRIVER_API_URL = getDriverAPIURL();

const getToken = () => localStorage.getItem('driver_token');

const driverApi = axios.create({
  baseURL: DRIVER_API_URL,
});

driverApi.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

driverApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('driver_token');
      localStorage.removeItem('driver_info');
      window.location.href = '/driver/login';
    }
    return Promise.reject(error);
  }
);

export { driverApi, getToken, DRIVER_API_URL };
